import React from 'react'
import { Input, Card, Tooltip } from 'antd'
import { useFormikContext } from 'formik'
import { FormField } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const HeroSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const heroImagePath = useFieldPath('sections.hero.heroImage')
  const titlePath = useFieldPath('sections.hero.title')
  const subtitlePath = useFieldPath('sections.hero.subtitle')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>
          <Tooltip title="URL da imagem hero da página de detalhe do curso">
            Imagem Hero
          </Tooltip>
        </label>
        <Input
          name={heroImagePath}
          value={get(values, heroImagePath, '')}
          onChange={handleChange}
          placeholder="https://exemplo.com/imagem-hero.jpg"
        />
      </FormField>
      <FormField>
        <label>Título</label>
        <Input
          name={titlePath}
          value={get(values, titlePath, '')}
          onChange={handleChange}
          placeholder="Título principal do curso"
        />
      </FormField>
      <FormField>
        <label>Subtítulo</label>
        <TextArea
          name={subtitlePath}
          value={get(values, subtitlePath, '')}
          onChange={handleChange}
          rows={2}
          placeholder="Subtítulo ou descrição curta"
        />
      </FormField>
    </Card>
  )
}
